import React from 'react';
import DefaultModal from 'components/Modal/DefaultModal';
import FilterClientScreen from '../FilterClientScreen';

const ModalFilterClients = ({
  isModalOpen,
  onModalToggle,
  setSelectedClient,
  handleSelectMultiContact,
  setInitMultiContactModal,
  setSelectedRows,
  ...props
}) => {
  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Buscar contatos por campo específico"
      showCloseButton={false}
      modalContainerClasses="modal-lg"
      size="xl"
      {...props}
    >
      <FilterClientScreen
        setSelectedClient={setSelectedClient}
        handleSelectMultiContact={handleSelectMultiContact}
        setInitMultiContactModal={setInitMultiContactModal}
        setSelectedRows={setSelectedRows}
      />
      {/* <Pagination activePage={page} totalItemsCount={32} onChange={() => {}} /> */}
    </DefaultModal>
  );
};

export default ModalFilterClients;
